export enum TokenTypeEnum {
    Admin = 'admin',
    Vendor = 'vendor',
    Device = 'device',
}
